'use strict';

angular
    .module('webmailWrapper')
    .service('alertManager', function (toastr, errorMapper, translationProvider) {
        this.success = function(message, fallback) {
            if (angular.isObject(message)) {
                message = errorMapper.map(message);
            }

            toastr.success(message ? message : fallback);
        };

        this.warning = function(message, fallback) {
            if (angular.isObject(message)) {
                message = errorMapper.map(message);
            }

            toastr.warning(message ? message : fallback);
        };

        this.error = function(message, fallback) {
            if (angular.isObject(message)) {
                message = errorMapper.map(message);
            }

            toastr.error(message ? message : fallback, translationProvider.instant('GENERAL.TOASTR.ERROR-TITLE'));
        };

        this.info = function(message, fallback) {
            if (angular.isObject(message)) {
                message = errorMapper.map(message);
            }

            toastr.info(message ? message : fallback);
        };
    })
    .service('rpcAlertManager', function (toastr, translationProvider) {
        var options = {
            timeOut: 0,
            extendedTimeOut: 0,
            closeButton: true
        };
        var robotMap = {
            account: translationProvider.instant('TR_140119-b3b187_TR'),
            billing: translationProvider.instant('TR_300119-887e33_TR'),
            domain: translationProvider.instant('TR_140119-3834d8_TR'),
            dns: translationProvider.instant('MENU.MAIN.PRODUCTS.DNS'),
            email: translationProvider.instant('TR_080119-8dd4a1_TR'),
            ssl: translationProvider.instant('MENU.MAIN.PRODUCTS.SSL'),
            webhosting: translationProvider.instant('TR_090119-12c8cf_TR')
        };

        this.robotNotAvailable = function(robot) {
            var message = translationProvider.instant('ERRORS.ROBOTS.IN-MAINTENANCE.TITLE', robotMap[robot]);
            toastr.error(message, translationProvider.instant('ERRORS.ROBOTS.NOT-AVAILABLE.MESSAGE'), options);
        };

        this.robotInMaintenance = function(robot) {
            var message = translationProvider.instant('ERRORS.ROBOTS.IN-MAINTENANCE.TITLE', robotMap[robot]);
            toastr.error(message, translationProvider.instant('ERRORS.ROBOTS.IN-MAINTENANCE.MESSAGE'), options);
        };
    });
